export enum DateLocales {
  ptBr = 'pt-br',
  enUs = 'en-US'
}
